<template>
  <div class="kontrollerPointOneComp">
    <tbl-one-comp :rows="pointTbl"/>
  </div>
</template>

<script>
export default {
  name: 'kontrollerPointOneComp',
  props: {
    params: {
      type: Object,
      default: function () { return {} }
    }
  },
  data: function () {
    return {
      moduleName: 'kontrollers',
      required: ['POINT_ID', 'POINT_NAME', 'POINT_CODE', 'POINT_REGION', 'POINT_OBLAST', 'POINT_GOROD', 'POINT_ULICA', 'POINT_DOM', 'POINT_INF_TYPE', 'POINT_CONTACTS', 'POINT_ARENDA']
    }
  },
  created: function () {
    // this.$store.dispatch(`${this.moduleName}/getOne`, {params: this.params, required: this.required});
  },
  components: {
  },
  computed: {
    pointTbl: function () {
      let model = this.$store.getters[`${this.moduleName}/getOne`]
      return this.$helpers.mapper.modelRequired(this.required, model)
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
